<div >
    <canvas [height]="hieght" #canvas aria-label="Line-Chart" role="img"></canvas>
</div>
